import { catTipoCambio } from "../../constant/catTipoCambios"
import { Alert } from '@material-ui/lab'
import useCatalogos from "./../../hooks/useCatalogos"
import { FormatoFecha } from "../../utils/FormatFecha"
import { formatDinero } from "../../utils/formatDinero"
const InfoTipoCambio = ({ Banxico = false, DisabledPadding = false }) => {
    const cambio = useCatalogos(`TipoCambio/${catTipoCambio.DOLARES}`);
    return (
        <Alert className="alerta" severity="info" style={{padding: (DisabledPadding) ? "0" : "6px 16px"}}>
            Tipo de cambio hoy: <b>{FormatoFecha({ date: new Date(), formato: "dd MMMM yyy" })}</b> Dólar Dooddo: <b>{formatDinero(cambio?.TipoCambio)}</b> {(Banxico) ? <span>Dólar Banxico: <b>{formatDinero(cambio?.TipoCambioBanxico)}</b></span>: '' } 
        </Alert>
    )
}
export default InfoTipoCambio